import React from 'react';
import { bool, shape, string } from 'prop-types';

const SoilSampler = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.9999 11.33L17.9999 18H5.99993L10.9999 11.33V6H12.9999V11.33ZM15.9599 4H8.03993C7.61993 4 7.38993 4.48 7.64993 4.81L8.99993 6.5V10.67L3.19993 18.4C2.70993 19.06 3.17993 20 3.99993 20H19.9999C20.8199 20 21.2899 19.06 20.7999 18.4L14.9999 10.67V6.5L16.3499 4.81C16.6099 4.48 16.3799 4 15.9599 4Z" fill="currentColor" />
  </svg>
);

SoilSampler.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default SoilSampler;
